
export const DAYS = ["SUN", "MON", "TUE","WED","THU","FRI","SAT"];

// get the months
export const MONTHS = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC"
];

export const MOCKEVENTS = [
    { date: new Date(2023,11,11), title:"appointment", id: 1},
    { date: new Date(2023,11,26), title:"meeting with dean", id:2},
    { date: new Date(2023,11,30), title:"document approval", id:3},
];